import logo from './logo.svg';
import { Routes,Route} from 'react-router-dom'
import './App.css';
import Login from './Components/Login/login';
import  UserAuthContextProvider  from './Components/Login/UserAuthContext';
import Contactlist from './Components/ChatRoom/Contactlist';
import ChatRoom from './Components/ChatRoom/ChatRoom';
function App() {
  return (
    <UserAuthContextProvider>
      <Routes>
        <Route path='/' element={<Login/>}/>
        <Route path='/contactlist' element={<Contactlist/>}/>
        <Route path='/chatroom:idRoom' element={<ChatRoom/>}/>
      </Routes>
    </UserAuthContextProvider>
  )  
}

export default App;
